
import Vue from 'vue'
import { PaymentDto } from '@ViewModels/PaymentDto'
import { Alert, Currency } from '@/components'
import { SaveButton } from '@/components/buttons'
import { Textbox, Currencybox } from '@/components/formGroups'

export default Vue.extend({
   name: 'PaymentPage',
   props: {
      data: { required: true, type: Object as () => PaymentDto },
      displayData: { required: true, type: Object },
   },
   data() {
      return {
         submitted: false,
      }
   },
   computed: {
      validationMessages(): string[] {
         const messages: string[] = []
         if (!this.data.InvoiceNumber) {
            messages.push('Invoice Number is missing')
         }
         if (!this.data.CustomerNumber) {
            messages.push('Account Number is missing')
         }
         if (this.data.PaymentAmount < 0) {
            messages.push('Invoice Total must be positive')
         }
         if (+this.data.PaymentAmount === 0) {
            messages.push('Invoice Total cannot be zero')
         }
         if (+this.data.PaymentAmount > 10_000) {
            messages.push('Invoice Total cannot be more than $10,000')
         }
         return messages
      },
      isValid(): boolean {
         return this.validationMessages.length === 0
      },
      allowSubmission(): boolean {
         return !this.submitted || this.isValid
      },
      showValidationError(): boolean {
         return !this.isValid && this.submitted
      },
   },
   methods: {
      submit() {
         this.submitted = true
         if (this.isValid) {
            this.$emit('click')
         }
      },
   },
   components: {
      Alert,
      Textbox,
      SaveButton,
      Currency,
      Currencybox,
   },
})
